export default __webpack_public_path__ + "static/swanson-28c1277418fc9a2cb924a9b81ac2107b.jpg";